import * as React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import MenuOverlay from './MenuOverlay';
import CaseStudiesOverlay from './CaseStudiesOverlay';

class Overlay extends React.PureComponent {
  componentWillMount() {
    window.scrollTo(0, 0);
  }

  render() {
    const { overlay } = this.props;

    if (overlay.overlayType === 'menu') {
      return <MenuOverlay />;
    }
    return <CaseStudiesOverlay />;
  }
}

Overlay.defaultProps = {
  overlay: {}
};

Overlay.propTypes = {
  overlay: PropTypes.object
};

const mapStateToProps = state => ({
  overlay: state.overlay
});

export default connect(mapStateToProps)(Overlay);



// WEBPACK FOOTER //
// ./src/components/Overlay/index.jsx